export default "__VITE_ASSET__BTCE8zWC__"